import slugify from '@sindresorhus/slugify';

function getFirstName(name: string) {
  return name.split(` `)[0];
}

/**
  1 author: Full name
  2 authors: First Name & First Name
  3+ authors: First Name, First Name, & x more
*/
export function resolveAuthorsName(authors: { name: string }[]) {
  if (!authors) return ``;

  if (authors.length === 1) {
    return authors[0].name;
  }

  const firstName = getFirstName(authors[0].name);
  const secondName = getFirstName(authors[1].name);

  return authors.length === 2
    ? `${firstName} & ${secondName}`
    : `${firstName}, ${secondName}, & ${authors.length - 2} more`;
}

export function slugifyHeading(heading: string) {
  return slugify(heading, {
    customReplacements: [
      [`/`, ``],
      [`.`, ``],
    ],
    decamelize: false,
  });
}

type GetPagination = {
  page: number;
  offset: number;
};

export function getPagination({
  queryPage,
  limit,
}: {
  queryPage: string | string[] | undefined;
  limit: number;
}): GetPagination {
  const pageParam = Array.isArray(queryPage) ? queryPage[0] : queryPage;
  const pageNumber = Number(pageParam || 1);

  const page = pageNumber > 0 ? pageNumber : 1;
  const offset = Number((page - 1) * limit);

  return {
    page,
    offset,
  };
}
